import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-userrights',
  templateUrl: './userrights.component.html',
  styleUrls: ['./userrights.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserrightsComponent implements OnInit {
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  searchText: string;
  RoleName: string;
  Description: string;
  Status: boolean = false;
  AduitUploadRead: boolean = false;
  AduitUploadWrite: boolean = false;
  AuditOutputRead: boolean = false;
  AuditOutputWrite: boolean = false;
  ChaRead: boolean = false;
  ChaWrite: boolean = false;
  CountryRead: boolean = false;
  CountryWrite: boolean = false;
  CurrencyRead: boolean = false;
  CurrencyWrite: boolean = false;
  ExchangeRead: boolean = false;
  ExchangeWrite: boolean = false;
  PortRead: boolean = false;
  PortWrite: boolean = false;
  CustomRead: boolean = false;
  CustomWrite: boolean = false;
  EximRead: boolean = false;
  EximWrite: boolean = false;
  AntiDumbingRead: boolean = false;
  AntiDumbingWrite: boolean = false;
  ClientRead: boolean = false;
  ClientWrite: boolean = false;
  OnboardingRead: boolean = false;
  OnboardingWrite: boolean = false;
  ContractsRead: boolean = false;
  ContractsWrite: boolean = false;
  NdaRead: boolean = false;
  NdaWrite: boolean = false;
  EmployeeRead: boolean = false;
  EmployeeWrite: boolean = false;
  AssignEmpRead: boolean = false;
  AssignEmpWrite: boolean = false;
  PartsRead: boolean = false;
  PartsWrite: boolean = false;
  LicenseRead: boolean = false;
  LicenseWrite: boolean = false;
  BondRead: boolean = false;
  BondWrite: boolean = false;
  BankRead: boolean = false;
  BankWrite: boolean = false;
  ImportPartRead: boolean = false;
  ImportPartWrite: boolean = false;
  UserRightsRead: boolean = false;
  UserRightsWrite: boolean = false;
  RoleExport = [] as any;
  EditedRole = [] as any;
  EditedRoleId: string;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'roleName','status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('UserRightsRead');
    this.vWrite = localStorage.getItem('UserRightsWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
//[hidden]="isShownWrite"
    this.BindUserRoleGrid();
    this.BindUserRoleExport();
  }

  BindUserRoleGrid() {
    var value = this.http.get(environment.apiUrl + 'UserRights/GetUserRigntsForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }
  BindUserRoleExport() {
    var value = this.http.get(environment.apiUrl + 'UserRights/GetUserRigntsForExport').toPromise().then(
      (data: any) => {

        this.RoleExport = data;
      });
  }

  SubmitClick() {
    if (this.RoleName == undefined || this.RoleName == null || this.RoleName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Role Name.";
      return false;
    }
    if (this.AduitUploadRead == false && this.AduitUploadWrite == false && this.AuditOutputRead == false
      && this.AuditOutputWrite == false && this.ChaRead == false && this.ChaWrite == false
      && this.CountryRead == false && this.CountryWrite == false && this.CurrencyRead == false
      && this.CurrencyWrite == false && this.ExchangeRead == false && this.ExchangeWrite == false
      && this.PortRead == false && this.PortWrite == false && this.CustomRead == false
      && this.CustomWrite == false && this.EximRead == false && this.EximWrite == false
      && this.AntiDumbingRead == false && this.AntiDumbingWrite == false && this.ClientRead == false
      && this.ClientWrite == false && this.OnboardingRead == false && this.OnboardingWrite == false &&
      this.ContractsRead == false && this.ContractsWrite == false && this.NdaRead == false && this.NdaWrite == false &&
      this.EmployeeRead == false && this.EmployeeWrite == false && this.AssignEmpRead == false && this.AssignEmpWrite == false &&
      this.PartsRead == false && this.PartsWrite == false && this.LicenseRead == false && this.LicenseWrite == false
      && this.BondRead == false && this.BondWrite == false && this.BankRead == false && this.BankWrite == false
      && this.ImportPartRead == false && this.ImportPartWrite == false && this.UserRightsRead == false && this.UserRightsWrite == false) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Atlease One User Rights.";
      return false;
    }
    var vUserRights = "";
    if (this.AduitUploadRead == true) {
      if (vUserRights == "")
        vUserRights = "AduitUploadRead";
      else
        vUserRights = vUserRights + "|AduitUploadRead";
    }
    if (this.AduitUploadWrite == true) {
      if (vUserRights == "")
        vUserRights = "AduitUploadWrite";
      else
        vUserRights = vUserRights + "|AduitUploadWrite";
    }
    if (this.AuditOutputRead == true) {
      if (vUserRights == "")
        vUserRights = "AuditOutputRead";
      else
        vUserRights = vUserRights + "|AuditOutputRead";
    }
    if (this.AuditOutputWrite == true) {
      if (vUserRights == "")
        vUserRights = "AuditOutputWrite";
      else
        vUserRights = vUserRights + "|AuditOutputWrite";
    }
    if (this.ChaRead == true) {
      if (vUserRights == "")
        vUserRights = "ChaRead";
      else
        vUserRights = vUserRights + "|ChaRead";
    }
    if (this.ChaWrite == true) {
      if (vUserRights == "")
        vUserRights = "ChaWrite";
      else
        vUserRights = vUserRights + "|ChaWrite";
    }
    if (this.CountryRead == true) {
      if (vUserRights == "")
        vUserRights = "CountryRead";
      else
        vUserRights = vUserRights + "|CountryRead";
    }
    if (this.CountryWrite == true) {
      if (vUserRights == "")
        vUserRights = "CountryWrite";
      else
        vUserRights = vUserRights + "|CountryWrite";
    }
    if (this.CurrencyRead == true) {
      if (vUserRights == "")
        vUserRights = "CurrencyRead";
      else
        vUserRights = vUserRights + "|CurrencyRead";
    }
    if (this.CurrencyWrite == true) {
      if (vUserRights == "")
        vUserRights = "CurrencyWrite";
      else
        vUserRights = vUserRights + "|CurrencyWrite";
    }
    if (this.ExchangeRead == true) {
      if (vUserRights == "")
        vUserRights = "ExchangeRead";
      else
        vUserRights = vUserRights + "|ExchangeRead";
    }
    if (this.ExchangeWrite == true) {
      if (vUserRights == "")
        vUserRights = "ExchangeWrite";
      else
        vUserRights = vUserRights + "|ExchangeWrite";
    }
    if (this.PortRead == true) {
      if (vUserRights == "")
        vUserRights = "PortRead";
      else
        vUserRights = vUserRights + "|PortRead";
    }
    if (this.PortWrite == true) {
      if (vUserRights == "")
        vUserRights = "PortWrite";
      else
        vUserRights = vUserRights + "|PortWrite";
    }
    if (this.CustomRead == true) {
      if (vUserRights == "")
        vUserRights = "CustomRead";
      else
        vUserRights = vUserRights + "|CustomRead";
    }
    if (this.CustomWrite == true) {
      if (vUserRights == "")
        vUserRights = "CustomWrite";
      else
        vUserRights = vUserRights + "|CustomWrite";
    }
    if (this.EximRead == true) {
      if (vUserRights == "")
        vUserRights = "EximRead";
      else
        vUserRights = vUserRights + "|EximRead";
    }
    if (this.EximWrite == true) {
      if (vUserRights == "")
        vUserRights = "EximWrite";
      else
        vUserRights = vUserRights + "|EximWrite";
    }
    if (this.AntiDumbingRead == true) {
      if (vUserRights == "")
        vUserRights = "AntiDumbingRead";
      else
        vUserRights = vUserRights + "|AntiDumbingRead";
    }
    if (this.AntiDumbingWrite == true) {
      if (vUserRights == "")
        vUserRights = "AntiDumbingWrite";
      else
        vUserRights = vUserRights + "|AntiDumbingWrite";
    }
    if (this.ClientRead == true) {
      if (vUserRights == "")
        vUserRights = "ClientRead";
      else
        vUserRights = vUserRights + "|ClientRead";
    }
    if (this.ClientWrite == true) {
      if (vUserRights == "")
        vUserRights = "ClientWrite";
      else
        vUserRights = vUserRights + "|ClientWrite";
    }
    if (this.OnboardingRead == true) {
      if (vUserRights == "")
        vUserRights = "OnboardingRead";
      else
        vUserRights = vUserRights + "|OnboardingRead";
    }
    if (this.OnboardingWrite == true) {
      if (vUserRights == "")
        vUserRights = "OnboardingWrite";
      else
        vUserRights = vUserRights + "|OnboardingWrite";
    }
    if (this.ContractsRead == true) {
      if (vUserRights == "")
        vUserRights = "ContractsRead";
      else
        vUserRights = vUserRights + "|ContractsRead";
    }
    if (this.ContractsWrite == true) {
      if (vUserRights == "")
        vUserRights = "ContractsWrite";
      else
        vUserRights = vUserRights + "|ContractsWrite";
    }
    if (this.NdaRead == true) {
      if (vUserRights == "")
        vUserRights = "NdaRead";
      else
        vUserRights = vUserRights + "|NdaRead";
    }
    if (this.NdaWrite == true) {
      if (vUserRights == "")
        vUserRights = "NdaWrite";
      else
        vUserRights = vUserRights + "|NdaWrite";
    }
    if (this.EmployeeRead == true) {
      if (vUserRights == "")
        vUserRights = "EmployeeRead";
      else
        vUserRights = vUserRights + "|EmployeeRead";
    }
    if (this.EmployeeWrite == true) {
      if (vUserRights == "")
        vUserRights = "EmployeeWrite";
      else
        vUserRights = vUserRights + "|EmployeeWrite";
    }
    if (this.AssignEmpRead == true) {
      if (vUserRights == "")
        vUserRights = "AssignEmpRead";
      else
        vUserRights = vUserRights + "|AssignEmpRead";
    }
    if (this.AssignEmpWrite == true) {
      if (vUserRights == "")
        vUserRights = "AssignEmpWrite";
      else
        vUserRights = vUserRights + "|AssignEmpWrite";
    }
    if (this.PartsRead == true) {
      if (vUserRights == "")
        vUserRights = "PartsRead";
      else
        vUserRights = vUserRights + "|PartsRead";
    }
    if (this.PartsWrite == true) {
      if (vUserRights == "")
        vUserRights = "PartsWrite";
      else
        vUserRights = vUserRights + "|PartsWrite";
    }

    if (this.LicenseRead == true) {
      if (vUserRights == "")
        vUserRights = "LicenseRead";
      else
        vUserRights = vUserRights + "|LicenseRead";
    }
    if (this.LicenseWrite == true) {
      if (vUserRights == "")
        vUserRights = "LicenseWrite";
      else
        vUserRights = vUserRights + "|LicenseWrite";
    }

    if (this.BondRead == true) {
      if (vUserRights == "")
        vUserRights = "BondRead";
      else
        vUserRights = vUserRights + "|BondRead";
    }
    if (this.BondWrite == true) {
      if (vUserRights == "")
        vUserRights = "BondWrite";
      else
        vUserRights = vUserRights + "|BondWrite";
    }
    if (this.BankRead == true) {
      if (vUserRights == "")
        vUserRights = "BankRead";
      else
        vUserRights = vUserRights + "|BankRead";
    }
    if (this.BankWrite == true) {
      if (vUserRights == "")
        vUserRights = "BankWrite";
      else
        vUserRights = vUserRights + "|BankWrite";
    }
    if (this.ImportPartRead == true) {
      if (vUserRights == "")
        vUserRights = "ImportPartRead";
      else
        vUserRights = vUserRights + "|ImportPartRead";
    }
    if (this.ImportPartWrite == true) {
      if (vUserRights == "")
        vUserRights = "ImportPartWrite";
      else
        vUserRights = vUserRights + "|ImportPartWrite";
    }
    if (this.UserRightsRead == true) {
      if (vUserRights == "")
        vUserRights = "UserRightsRead";
      else
        vUserRights = vUserRights + "|UserRightsRead";
    }
    if (this.UserRightsWrite == true) {
      if (vUserRights == "")
        vUserRights = "UserRightsWrite";
      else
        vUserRights = vUserRights + "|UserRightsWrite";
    }

    let params = new HttpParams();
    params = params.append('sRoleName', this.RoleName);
    params = params.append('sUserrRights', vUserRights);
    params = params.append('sDescription', this.Description);
    var value = this.http.get(environment.apiUrl + 'UserRights/InsertUserRignts', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        //var currencycode = data;
        //this.RoleName = "";
        //this.Description = "";
        //this.CurrencyName = "";
        //this.SuccessMsg = "User Rights Added."
        //this.BindCurrencyGrid();
        //this.BindCurrencyExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Success") {
          this.BindUserRoleGrid();
          this.BindUserRoleExport();
          this.isShownSuccess = false;
          this.SuccessMsg = "User Rights Added.";
          this.RoleName = "";
          this.Description = "";
          this.Status = false;
          this.AduitUploadRead = false;
          this.AduitUploadWrite = false;
          this.AuditOutputRead = false;
          this.AuditOutputWrite = false;
          this.ChaRead = false;
          this.ChaWrite = false;
          this.CountryRead = false;
          this.CountryWrite = false;
          this.CurrencyRead = false;
          this.CurrencyWrite = false;
          this.ExchangeRead = false;
          this.ExchangeWrite = false;
          this.PortRead = false;
          this.PortWrite = false;
          this.CustomRead = false;
          this.CustomWrite = false;
          this.EximRead = false;
          this.EximWrite = false;
          this.AntiDumbingRead = false;
          this.AntiDumbingWrite = false;
          this.ClientRead = false;
          this.ClientWrite = false;
          this.OnboardingRead = false;
          this.OnboardingWrite = false;
          this.ContractsRead = false;
          this.ContractsWrite = false;
          this.NdaRead = false;
          this.NdaWrite = false;
          this.EmployeeRead = false;
          this.EmployeeWrite = false;
          this.AssignEmpRead = false;
          this.AssignEmpWrite = false;
          this.PartsRead = false;
          this.PartsWrite = false;
          this.LicenseRead = false;
          this.LicenseWrite = false;
          this.BondRead = false;
          this.BondWrite = false;
          this.BankRead = false;
          this.BankWrite = false;
          this.ImportPartRead = false;
          this.ImportPartWrite = false;
          this.UserRightsRead = false;
          this.UserRightsWrite = false;

          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Role Name Already Exist.";
          return false;
        }
        else {
        }
      });
  }
  ClearClick() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.isShownActive = true;
    this.RoleName = "";
    this.Description = "";
    this.EditedRole=[];
    this.EditedRoleId="";
    this.Status = false;
    this.AduitUploadRead = false;
    this.AduitUploadWrite = false;
    this.AuditOutputRead = false;
    this.AuditOutputWrite = false;
    this.ChaRead = false;
    this.ChaWrite = false;
    this.CountryRead = false;
    this.CountryWrite = false;
    this.CurrencyRead = false;
    this.CurrencyWrite = false;
    this.ExchangeRead = false;
    this.ExchangeWrite = false;
    this.PortRead = false;
    this.PortWrite = false;
    this.CustomRead = false;
    this.CustomWrite = false;
    this.EximRead = false;
    this.EximWrite = false;
    this.AntiDumbingRead = false;
    this.AntiDumbingWrite = false;
    this.ClientRead = false;
    this.ClientWrite = false;
    this.OnboardingRead = false;
    this.OnboardingWrite = false;
    this.ContractsRead = false;
    this.ContractsWrite = false;
    this.NdaRead = false;
    this.NdaWrite = false;
    this.EmployeeRead = false;
    this.EmployeeWrite = false;
    this.AssignEmpRead = false;
    this.AssignEmpWrite = false;
    this.PartsRead = false;
    this.PartsWrite = false;
    this.LicenseRead = false;
    this.LicenseWrite = false;
    this.BondRead = false;
    this.BondWrite = false;
    this.BankRead = false;
    this.BankWrite = false;
    this.ImportPartRead = false;
    this.ImportPartWrite = false;
    this.UserRightsRead = false;
    this.UserRightsWrite = false;
  }
  EditUserRights(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedRole = item;
    this.EditedRoleId = this.EditedRole.roleId;
    var vroleName = this.EditedRole.roleName;
    var vscreens = this.EditedRole.screens;
    var vdescription = this.EditedRole.description;
    var vstatus = this.EditedRole.status;

    this.RoleName = vroleName;
    this.Description = vdescription;
    if (vstatus == "Active")
      this.Status = false;
    else
      this.Status = true;

    var RoleScrn = vscreens.split("|");
    for (var i = 0; i < RoleScrn.length; i++) {
      switch (RoleScrn[i]) {
        case "AduitUploadRead": {
          this.AduitUploadRead = true;
          break;
        }
        case "AduitUploadWrite": {
          this.AduitUploadWrite = true;
          break;
        }
        case "AuditOutputRead": {
          this.AuditOutputRead = true;
          break;
        }
        case "AuditOutputWrite": {
          this.AuditOutputWrite = true;
          break;
        }
        case "ChaRead": {
          this.ChaRead = true;
          break;
        }
        case "ChaWrite": {
          this.ChaWrite = true;
          break;
        }
        case "CountryRead": {
          this.CountryRead = true;
          break;
        }
        case "CountryWrite": {
          this.CountryWrite = true;
          break;
        }

        case "CurrencyRead": {
          this.CurrencyRead = true;
          break;
        }
        case "CurrencyWrite": {
          this.CurrencyWrite = true;
          break;
        }

        case "ExchangeRead": {
          this.ExchangeRead = true;
          break;
        }

        case "ExchangeWrite": {
          this.ExchangeWrite = true;
          break;
        }
        case "PortRead": {
          this.PortRead = true;
          break;
        }
        case "PortWrite": {
          this.PortWrite = true;
          break;
        }
        case "CustomRead": {
          this.CustomRead = true;
          break;
        }
        case "CustomWrite": {
          this.CustomWrite = true;
          break;
        }
        case "EximRead": {
          this.EximRead = true;
          break;
        }
        case "EximWrite": {
          this.EximWrite = true;
          break;
        }
        case "AntiDumbingRead": {
          this.AntiDumbingRead = true;
          break;
        }
        case "AntiDumbingWrite": {
          this.AntiDumbingWrite = true;
          break;
        }
        case "ClientRead": {
          this.ClientRead = true;
          break;
        }
        case "ClientWrite": {
          this.ClientWrite = true;
          break;
        }
        case "OnboardingRead": {
          this.OnboardingRead = true;
          break;
        }
        case "OnboardingWrite": {
          this.OnboardingWrite = true;
          break;
        }
        case "ContractsRead": {
          this.ContractsRead = true;
          break;
        }
        case "ContractsWrite": {
          this.ContractsWrite = true;
          break;
        }
        case "NdaRead": {
          this.NdaRead = true;
          break;
        }
        case "NdaWrite": {
          this.NdaWrite = true;
          break;
        }
        case "EmployeeRead": {
          this.EmployeeRead = true;
          break;
        }
        case "EmployeeWrite": {
          this.EmployeeWrite = true;
          break;
        }

        case "AssignEmpRead": {
          this.AssignEmpRead = true;
          break;
        }
        case "AssignEmpWrite": {
          this.AssignEmpWrite = true;
          break;
        }
        case "PartsRead": {
          this.PartsRead = true;
          break;
        }
        case "PartsWrite": {
          this.PartsWrite = true;
          break;
        }
        case "LicenseRead": {
          this.LicenseRead = true;
          break;
        }
        case "LicenseWrite": {
          this.LicenseWrite = true;
          break;
        }
        case "BondRead": {
          this.BondRead = true;
          break;
        }
        case "BondWrite": {
          this.BondWrite = true;
          break;
        }
        case "BankRead": {
          this.BankRead = true;
          break;
        }
        case "BankWrite": {
          this.BankWrite = true;
          break;
        }
        case "ImportPartRead": {
          this.ImportPartRead = true;
          break;
        }
        case "ImportPartWrite": {
          this.ImportPartWrite = true;
          break;
        }
        case "UserRightsRead": {
          this.UserRightsRead = true;
          break;
        }
        case "UserRightsWrite": {
          this.UserRightsWrite = true;
          break;
        }

      }
    }

  }
  UpdateUserRights() {
    if (this.RoleName == undefined || this.RoleName == null || this.RoleName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Role Name.";
      return false;
    }
    if (this.AduitUploadRead == false && this.AduitUploadWrite == false && this.AuditOutputRead == false
      && this.AuditOutputWrite == false && this.ChaRead == false && this.ChaWrite == false
      && this.CountryRead == false && this.CountryWrite == false && this.CurrencyRead == false
      && this.CurrencyWrite == false && this.ExchangeRead == false && this.ExchangeWrite == false
      && this.PortRead == false && this.PortWrite == false && this.CustomRead == false
      && this.CustomWrite == false && this.EximRead == false && this.EximWrite == false
      && this.AntiDumbingRead == false && this.AntiDumbingWrite == false && this.ClientRead == false
      && this.ClientWrite == false && this.OnboardingRead == false && this.OnboardingWrite == false &&
      this.ContractsRead == false && this.ContractsWrite == false && this.NdaRead == false && this.NdaWrite == false &&
      this.EmployeeRead == false && this.EmployeeWrite == false && this.AssignEmpRead == false && this.AssignEmpWrite == false &&
      this.PartsRead == false && this.PartsWrite == false && this.LicenseRead == false && this.LicenseWrite == false
      && this.BondRead == false && this.BondWrite == false && this.BankRead == false && this.BankWrite == false
      && this.ImportPartRead == false && this.ImportPartWrite == false && this.UserRightsRead == false && this.UserRightsWrite == false) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Atlease One User Rights.";
      return false;
    }
    var vUserRights = "";
    if (this.AduitUploadRead == true) {
      if (vUserRights == "")
        vUserRights = "AduitUploadRead";
      else
        vUserRights = vUserRights + "|AduitUploadRead";
    }
    if (this.AduitUploadWrite == true) {
      if (vUserRights == "")
        vUserRights = "AduitUploadWrite";
      else
        vUserRights = vUserRights + "|AduitUploadWrite";
    }
    if (this.AuditOutputRead == true) {
      if (vUserRights == "")
        vUserRights = "AuditOutputRead";
      else
        vUserRights = vUserRights + "|AuditOutputRead";
    }
    if (this.AuditOutputWrite == true) {
      if (vUserRights == "")
        vUserRights = "AuditOutputWrite";
      else
        vUserRights = vUserRights + "|AuditOutputWrite";
    }
    if (this.ChaRead == true) {
      if (vUserRights == "")
        vUserRights = "ChaRead";
      else
        vUserRights = vUserRights + "|ChaRead";
    }
    if (this.ChaWrite == true) {
      if (vUserRights == "")
        vUserRights = "ChaWrite";
      else
        vUserRights = vUserRights + "|ChaWrite";
    }
    if (this.CountryRead == true) {
      if (vUserRights == "")
        vUserRights = "CountryRead";
      else
        vUserRights = vUserRights + "|CountryRead";
    }
    if (this.CountryWrite == true) {
      if (vUserRights == "")
        vUserRights = "CountryWrite";
      else
        vUserRights = vUserRights + "|CountryWrite";
    }
    if (this.CurrencyRead == true) {
      if (vUserRights == "")
        vUserRights = "CurrencyRead";
      else
        vUserRights = vUserRights + "|CurrencyRead";
    }
    if (this.CurrencyWrite == true) {
      if (vUserRights == "")
        vUserRights = "CurrencyWrite";
      else
        vUserRights = vUserRights + "|CurrencyWrite";
    }
    if (this.ExchangeRead == true) {
      if (vUserRights == "")
        vUserRights = "ExchangeRead";
      else
        vUserRights = vUserRights + "|ExchangeRead";
    }
    if (this.ExchangeWrite == true) {
      if (vUserRights == "")
        vUserRights = "ExchangeWrite";
      else
        vUserRights = vUserRights + "|ExchangeWrite";
    }
    if (this.PortRead == true) {
      if (vUserRights == "")
        vUserRights = "PortRead";
      else
        vUserRights = vUserRights + "|PortRead";
    }
    if (this.PortWrite == true) {
      if (vUserRights == "")
        vUserRights = "PortWrite";
      else
        vUserRights = vUserRights + "|PortWrite";
    }
    if (this.CustomRead == true) {
      if (vUserRights == "")
        vUserRights = "CustomRead";
      else
        vUserRights = vUserRights + "|CustomRead";
    }
    if (this.CustomWrite == true) {
      if (vUserRights == "")
        vUserRights = "CustomWrite";
      else
        vUserRights = vUserRights + "|CustomWrite";
    }
    if (this.EximRead == true) {
      if (vUserRights == "")
        vUserRights = "EximRead";
      else
        vUserRights = vUserRights + "|EximRead";
    }
    if (this.EximWrite == true) {
      if (vUserRights == "")
        vUserRights = "EximWrite";
      else
        vUserRights = vUserRights + "|EximWrite";
    }
    if (this.AntiDumbingRead == true) {
      if (vUserRights == "")
        vUserRights = "AntiDumbingRead";
      else
        vUserRights = vUserRights + "|AntiDumbingRead";
    }
    if (this.AntiDumbingWrite == true) {
      if (vUserRights == "")
        vUserRights = "AntiDumbingWrite";
      else
        vUserRights = vUserRights + "|AntiDumbingWrite";
    }
    if (this.ClientRead == true) {
      if (vUserRights == "")
        vUserRights = "ClientRead";
      else
        vUserRights = vUserRights + "|ClientRead";
    }
    if (this.ClientWrite == true) {
      if (vUserRights == "")
        vUserRights = "ClientWrite";
      else
        vUserRights = vUserRights + "|ClientWrite";
    }
    if (this.OnboardingRead == true) {
      if (vUserRights == "")
        vUserRights = "OnboardingRead";
      else
        vUserRights = vUserRights + "|OnboardingRead";
    }
    if (this.OnboardingWrite == true) {
      if (vUserRights == "")
        vUserRights = "OnboardingWrite";
      else
        vUserRights = vUserRights + "|OnboardingWrite";
    }
    if (this.ContractsRead == true) {
      if (vUserRights == "")
        vUserRights = "ContractsRead";
      else
        vUserRights = vUserRights + "|ContractsRead";
    }
    if (this.ContractsWrite == true) {
      if (vUserRights == "")
        vUserRights = "ContractsWrite";
      else
        vUserRights = vUserRights + "|ContractsWrite";
    }
    if (this.NdaRead == true) {
      if (vUserRights == "")
        vUserRights = "NdaRead";
      else
        vUserRights = vUserRights + "|NdaRead";
    }
    if (this.NdaWrite == true) {
      if (vUserRights == "")
        vUserRights = "NdaWrite";
      else
        vUserRights = vUserRights + "|NdaWrite";
    }
    if (this.EmployeeRead == true) {
      if (vUserRights == "")
        vUserRights = "EmployeeRead";
      else
        vUserRights = vUserRights + "|EmployeeRead";
    }
    if (this.EmployeeWrite == true) {
      if (vUserRights == "")
        vUserRights = "EmployeeWrite";
      else
        vUserRights = vUserRights + "|EmployeeWrite";
    }
    if (this.AssignEmpRead == true) {
      if (vUserRights == "")
        vUserRights = "AssignEmpRead";
      else
        vUserRights = vUserRights + "|AssignEmpRead";
    }
    if (this.AssignEmpWrite == true) {
      if (vUserRights == "")
        vUserRights = "AssignEmpWrite";
      else
        vUserRights = vUserRights + "|AssignEmpWrite";
    }
    if (this.PartsRead == true) {
      if (vUserRights == "")
        vUserRights = "PartsRead";
      else
        vUserRights = vUserRights + "|PartsRead";
    }
    if (this.PartsWrite == true) {
      if (vUserRights == "")
        vUserRights = "PartsWrite";
      else
        vUserRights = vUserRights + "|PartsWrite";
    }

    if (this.LicenseRead == true) {
      if (vUserRights == "")
        vUserRights = "LicenseRead";
      else
        vUserRights = vUserRights + "|LicenseRead";
    }
    if (this.LicenseWrite == true) {
      if (vUserRights == "")
        vUserRights = "LicenseWrite";
      else
        vUserRights = vUserRights + "|LicenseWrite";
    }

    if (this.BondRead == true) {
      if (vUserRights == "")
        vUserRights = "BondRead";
      else
        vUserRights = vUserRights + "|BondRead";
    }
    if (this.BondWrite == true) {
      if (vUserRights == "")
        vUserRights = "BondWrite";
      else
        vUserRights = vUserRights + "|BondWrite";
    }
    if (this.BankRead == true) {
      if (vUserRights == "")
        vUserRights = "BankRead";
      else
        vUserRights = vUserRights + "|BankRead";
    }
    if (this.BankWrite == true) {
      if (vUserRights == "")
        vUserRights = "BankWrite";
      else
        vUserRights = vUserRights + "|BankWrite";
    }
    if (this.ImportPartRead == true) {
      if (vUserRights == "")
        vUserRights = "ImportPartRead";
      else
        vUserRights = vUserRights + "|ImportPartRead";
    }
    if (this.ImportPartWrite == true) {
      if (vUserRights == "")
        vUserRights = "ImportPartWrite";
      else
        vUserRights = vUserRights + "|ImportPartWrite";
    }
    if (this.UserRightsRead == true) {
      if (vUserRights == "")
        vUserRights = "UserRightsRead";
      else
        vUserRights = vUserRights + "|UserRightsRead";
    }
    if (this.UserRightsWrite == true) {
      if (vUserRights == "")
        vUserRights = "UserRightsWrite";
      else
        vUserRights = vUserRights + "|UserRightsWrite";
    }

    var vStatus = "Active";

    if (this.Status == true)
      vStatus = "InActive";

    let params = new HttpParams();
    params = params.append('sRoleName', this.RoleName);
    params = params.append('sUserrRights', vUserRights);
    params = params.append('sDescription', this.Description);
    params = params.append('sStatus', vStatus);
    params = params.append('iRoleId', this.EditedRoleId);
    var value = this.http.get(environment.apiUrl + 'UserRights/UpdateUserRignts', { params: params }).toPromise().then(
      (data: any) => {
        debugger;

        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Success") {
          this.BindUserRoleGrid();
          this.BindUserRoleExport();
          this.isShownSuccess = false;
          this.SuccessMsg = "User Rights Updated.";
          this.RoleName = "";
          this.Description = "";
          this.EditedRole=[];
          this.EditedRoleId="";
          this.Status = false;
          this.AduitUploadRead = false;
          this.AduitUploadWrite = false;
          this.AuditOutputRead = false;
          this.AuditOutputWrite = false;
          this.ChaRead = false;
          this.ChaWrite = false;
          this.CountryRead = false;
          this.CountryWrite = false;
          this.CurrencyRead = false;
          this.CurrencyWrite = false;
          this.ExchangeRead = false;
          this.ExchangeWrite = false;
          this.PortRead = false;
          this.PortWrite = false;
          this.CustomRead = false;
          this.CustomWrite = false;
          this.EximRead = false;
          this.EximWrite = false;
          this.AntiDumbingRead = false;
          this.AntiDumbingWrite = false;
          this.ClientRead = false;
          this.ClientWrite = false;
          this.OnboardingRead = false;
          this.OnboardingWrite = false;
          this.ContractsRead = false;
          this.ContractsWrite = false;
          this.NdaRead = false;
          this.NdaWrite = false;
          this.EmployeeRead = false;
          this.EmployeeWrite = false;
          this.AssignEmpRead = false;
          this.AssignEmpWrite = false;
          this.PartsRead = false;
          this.PartsWrite = false;
          this.LicenseRead = false;
          this.LicenseWrite = false;
          this.BondRead = false;
          this.BondWrite = false;
          this.BankRead = false;
          this.BankWrite = false;
          this.ImportPartRead = false;
          this.ImportPartWrite = false;
          this.UserRightsRead = false;
          this.UserRightsWrite = false;

          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          // this.isShownError = false;
          // this.ErrorMsg = "Role Name Already Exist.";
          // return false;
        }
        else {
        }
      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.RoleExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'UserRights');

    /* save to file */
    XLSX.writeFile(wb, "UserRights.xlsx");

  }

}
